import React from "react";
import { Select } from "@amzn/stencil-react-components/form";
import { Row, Spacer } from "@amzn/stencil-react-components/layout";
import { Label } from "@amzn/stencil-react-components/text";
import { useAppDispatch, useAppSelector } from "src/state/hooks";
import { IconWithTooltip } from "src/components/helperComponents/IconWithTooltip"
import { updateTrigger } from "src/state/slice/EventModelSlice";
import * as triggerConfigs from "src/config/triggerConfigs.json";
import "src/components/commonStyles.scss";

const STRINGS_DISPLAYED = {
  trigger_label: "Trigger",
  trigger_placeholder: "Choose a trigger",
}

type TriggerSelectorProps = {
  disabled?: boolean
  triggersAndSolutionTypes: string[]
}
/**
 * Renders the trigger selector component.
 */
export const TriggerSelector = ({disabled = false, triggersAndSolutionTypes}: TriggerSelectorProps) => {
  const dispatch = useAppDispatch();
  const eventModelState = useAppSelector(({eventModel}) => eventModel);
  const triggerOptions = Object.keys(triggerConfigs).filter(trigger => triggersAndSolutionTypes.includes(trigger))
    .map(trigger => triggerConfigs[trigger].triggerName);

  return <Row 
    alignItems={"center"} 
    justifyContent={"space-between"}
    width={"fit-content"}
  >
    <Label 
      fontSize={"20px"} 
      fontWeight={"bold"} 
      htmlFor="event-trigger"
      className={"width_200_px"}
    >
      {STRINGS_DISPLAYED.trigger_label}
    </Label>
    <Select
      id={"event-trigger"}
      options={triggerOptions}
      onChange={(value) => {
        dispatch(updateTrigger(value));
      }}
      value={eventModelState.trigger}
      width={"400px"}
      placeholder={STRINGS_DISPLAYED.trigger_placeholder}
      disabled={disabled}
    />

    {eventModelState?.clientUseCase && triggerConfigs[eventModelState.clientUseCase]?.description &&
      <>
        <Spacer width={"4px"}/>
        <IconWithTooltip
          tooltipText={triggerConfigs[eventModelState.clientUseCase].description}
          color={"primary70"}
        />
      </>}
  </Row>;
}
